import type { DoctorSpeciality, DoctorSpecialityCheckResult, DoctorBabyblogArticle } from '~/domains/doctor/Doctor.types'
import { useDoctorRepository } from '~/domains/doctor/DoctorRepository'

// Узкий port: вызывающая страница передаёт $storeModules.auth напрямую (без
// адаптера — ничего резолвить не нужно), поэтому узость типа не требует обёртки
// с get-аксессорами — auth остаётся тем же живым модулем.
export type DoctorSpecialitiesStorePort = {
  auth: {
    specialities: DoctorSpeciality[]
    setSpecialities: (specialities: DoctorSpeciality[]) => void
  }
}

export function useDoctorService () {
  const DoctorRepository = useDoctorRepository()

  const fetchSpecialities = async (store: DoctorSpecialitiesStorePort) => {
    if (store.auth.specialities.length) {
      return store.auth.specialities
    }

    const specialities = await DoctorRepository.getSpecialities()
    store.auth.setSpecialities(specialities)

    return specialities
  }

  const checkSpecialityByText = (text: string): Promise<DoctorSpecialityCheckResult> =>
    DoctorRepository.getSpecialityByText(text)

  const fetchArticlesByDoctor = (doctorId: string | undefined, page = 0): Promise<DoctorBabyblogArticle[]> =>
    DoctorRepository.getArticlesByDoctor(doctorId, page)

  return {
    fetchSpecialities,
    checkSpecialityByText,
    fetchArticlesByDoctor
  }
}
